import * as React from "react";
function useThenable(create) {
  var [promise] = React.useState(create);
  var initialState = [
    false,
    void 0
  ];
  promise.then(function(result) {
    initialState = [
      true,
      result
    ];
  });
  var [state, setState] = React.useState(initialState);
  var [resolved] = state;
  React.useEffect(function() {
    var cancelled = false;
    var resolve = async function resolve2() {
      var result;
      try {
        result = await promise;
      } finally {
        if (!cancelled) {
          setState([
            true,
            result
          ]);
        }
      }
    };
    if (!resolved) {
      resolve();
    }
    return function() {
      cancelled = true;
    };
  }, [
    promise,
    resolved
  ]);
  return state;
}
export {
  useThenable
};
//# sourceMappingURL=useThenable.js.map
